import { motion, AnimatePresence } from "framer-motion";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../../../context";
import { Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { schemaActaPaso1 } from "../../../schemas/validacionesActa";
import { getTipos } from "../../../api/tipos";
import Loading from "../../../components/Loading";
import { getBarrios } from "../../../api/barrios";
import { createActaPaso1 } from "../../../api/acta";
import { useFormActaStore } from "../../../store/formActaStore";
import { primeraEtapaHandler } from "../../../handlers/actas.handler";
import { useGeneralAppStore } from "../../../store/generalAppStore";
import useWindowSize from "../../../hooks/useWindowSize";
import { handlerCargaBarrios } from "../../../handlers/formPasos.handler";
import ArrowDerechoIcon from "../../../components/svgs/ArrowDerechoIcon";

const FormActa1 = () => {
  const size = useWindowSize();
  const { width } = size;

  const [sectoresState, setSectoresState] = useState();

  const { loading, tipos, barrios, setLoading, setUltimoPaso, setActaId, defaultValues } =
    useFormActaStore();
  const { loads } = useGeneralAppStore();
  const { actions: ua } = useContext(UserContext);
  const perfil = ua.getPerfil();

  const {
    resetField,
    register,
    watch,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm({
    defaultValues: defaultValues,
    resolver: yupResolver(schemaActaPaso1),
  });

  const validateSector = () => {
    let error = [];
    if (sectoresState?.length > 0 && !watch("sector")) {
      console.log("entre");
      setError("sector", {
        type: "manual",
        message: "Elija un sector.",
      });
      error.push("errorSector");
    } else if (watch("sector") == "Otro" && !watch("otro_sector")) {
      setError("otro_sector", {
        type: "manual",
        message: "Describa otro sector.",
      });
      error.push("errorOtro");
    }

    if (error.length > 0) {
      return true;
    } else {
      return false;
    }
  };

  useEffect(() => {
    if (!barrios) {
      handlerCargaBarrios();
    }
  }, []);

  const onSubmit = (data) => {
    const validacion = validateSector();
    if (!validacion) {
      if (data.acepta_condiciones) {
        data.acepta_condiciones = 1;
      }
      if (data.sector == "Otro" && data.otro_sector) {
        data.sector = data.otro_sector;
      }

      primeraEtapaHandler({ ...data, user_id: perfil.usuarioID }, setUltimoPaso, setActaId);
    }
  };

  useEffect(() => {
    if (watch("barrio")) {
      const sectores = barrios.find((barrio) => barrio.nombre == watch("barrio"));
      setSectoresState(sectores.sectores);
    }
    resetField("sector");
  }, [watch("barrio")]);

  useEffect(() => {
    resetField("otro_sector");
  }, [watch("sector")]);

  return (
    <>
      <motion.div
        key="form"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.5 /* delay: 1 */ }}
        style={{ overflow: "hidden", backgroundColor: "" }}
        className="position-relative"
      >
        {(loads.includes("load_form") || loads.includes("carga_barrios")) && (
          <div
            className="position-absolute w-100 h-100 d-flex align-items-center justify-content-center"
            style={{ background: "rgba(255,255,255,0.8)" }}
          >
            <Loading sizeIcono="50px" sizeLoad="70px" font="16px" />
          </div>
        )}

        <Form noValidate onSubmit={handleSubmit(onSubmit)} className="col-11 mx-auto">
          {/* <h3>Paso 1 - Datos del ciudadano</h3> */}
          <section className="row">
            <Form.Group className={`${width >= 640 ? "col-6" : "col-12"}`}>
              <Form.Label>Nombre de ciudadano</Form.Label>
              <Form.Control
                type="text"
                {...register("nombre_ciudadano")}
                isInvalid={!!errors.nombre_ciudadano}
              />
              <Form.Control.Feedback className="mensajeError-sm mensajeError-md" type="invalid">
                {errors.nombre_ciudadano?.message}
              </Form.Control.Feedback>
              {!errors.nombre_ciudadano?.message && <div style={{ height: "25px" }}></div>}
            </Form.Group>

            <Form.Group className={`${width >= 640 ? "col-3" : "col-6"}`}>
              <Form.Label>Documento</Form.Label>
              <Form.Control
                onInput={(e) => {
                  const value = e.target.value;
                  if (value.length > 9) {
                    e.target.value = value.slice(0, 9);
                  }
                }}
                type="number"
                {...register("dni")}
                onKeyDown={(e) => {
                  if (["ArrowUp", "ArrowDown", "e", "E", "+", "-", ".", ","].includes(e.key)) {
                    e.preventDefault();
                  }
                }}
                onWheel={(e) => e.currentTarget.blur()}
                isInvalid={!!errors.dni}
              />
              <Form.Control.Feedback className="mensajeError-sm mensajeError-md" type="invalid">
                {errors.dni?.message}
              </Form.Control.Feedback>
              {!errors.dni?.message && <div style={{ height: "25px" }}></div>}
            </Form.Group>

            <Form.Group className={`${width >= 640 ? "col-3" : "col-6"}`}>
              <Form.Label>Telefono</Form.Label>
              <Form.Control
                type="number"
                {...register("telefono")}
                onKeyDown={(e) => {
                  if (["ArrowUp", "ArrowDown", "e", "E", "+", "-", ".", ","].includes(e.key)) {
                    e.preventDefault();
                  }
                }}
                onInput={(e) => {
                  const value = e.target.value;
                  if (value.length > 15) {
                    e.target.value = value.slice(0, 15);
                  }
                }}
                onWheel={(e) => e.currentTarget.blur()}
                isInvalid={!!errors.telefono}
              />
              <Form.Control.Feedback className="mensajeError-sm mensajeError-md" type="invalid">
                {errors.telefono?.message}
              </Form.Control.Feedback>
              {!errors.telefono?.message && <div style={{ height: "25px" }}></div>}
            </Form.Group>

            <Form.Group className={`${width >= 640 ? "col-3" : "col-6"}`}>
              <Form.Label>Género</Form.Label>
              <Form.Select {...register("genero")} isInvalid={!!errors.genero}>
                <option value="">Seleccione opción</option>
                <option value="F">Femenino</option>
                <option value="M">Masculino</option>
                <option value="Otro">Otro</option>
              </Form.Select>
              <Form.Control.Feedback className="mensajeError-sm mensajeError-md" type="invalid">
                {errors.genero?.message}
              </Form.Control.Feedback>
              {!errors.genero?.message && <div style={{ height: "25px" }}></div>}
            </Form.Group>

            <Form.Group className={`${width >= 640 ? "col-2" : "col-6"}`}>
              <Form.Label>Edad</Form.Label>
              <Form.Control
                type="number"
                {...register("edad")}
                onKeyDown={(e) => {
                  if (["ArrowUp", "ArrowDown", "e", "E", "+", "-", ".", ","].includes(e.key)) {
                    e.preventDefault();
                  }
                }}
                onInput={(e) => {
                  const value = e.target.value;
                  if (value.length > 2) {
                    e.target.value = value.slice(0, 2);
                  }
                }}
                onWheel={(e) => e.currentTarget.blur()}
                isInvalid={!!errors.edad}
              />
              <Form.Control.Feedback className="mensajeError-sm mensajeError-md" type="invalid">
                {errors.edad?.message}
              </Form.Control.Feedback>
              {!errors.edad?.message && <div style={{ height: "25px" }}></div>}
            </Form.Group>

            <Form.Group className={`${width >= 640 ? "col-7" : "col-12"}`}>
              <Form.Label>Email</Form.Label>
              <Form.Control type="text" {...register("email")} isInvalid={!!errors.email} />
              <Form.Control.Feedback className="mensajeError-sm mensajeError-md" type="invalid">
                {errors.email?.message}
              </Form.Control.Feedback>
              {!errors.email?.message && <div style={{ height: "25px" }}></div>}
            </Form.Group>

            {/* <Form.Group className={` ${width <= 480 ? "col-12" : "col-6"}`}>
              <Form.Label>Tipo de acta</Form.Label>
              <Form.Select isInvalid={!!errors.tipo_id} {...register("tipo_id")}>
                <option value="">Seleccione un tipo</option>
                {tipos?.map((tipo) => (
                  <option disabled={tipo.id != 3} key={tipo.id} value={tipo.id}>
                    {tipo.nombre}
                  </option>
                ))}
              </Form.Select>
              <Form.Control.Feedback className="mensajeError-sm mensajeError-md" type="invalid">
                {errors.tipo_id?.message}
              </Form.Control.Feedback>
              {!errors.tipo_id?.message && <div style={{ height: "25px" }}></div>}
            </Form.Group> */}
            {width < 640 && (
              <Form.Group className={`${width >= 640 ? "col-12" : "col-12"}`}>
                <Form.Label>Domicilio</Form.Label>
                <Form.Control
                  type="text"
                  {...register("domicilio")}
                  isInvalid={!!errors.domicilio}
                />
                <Form.Control.Feedback className="mensajeError-sm mensajeError-md" type="invalid">
                  {errors.domicilio?.message}
                </Form.Control.Feedback>
                {!errors.domicilio?.message && <div style={{ height: "25px" }}></div>}
              </Form.Group>
            )}

            <div className={` ${width <= 640 ? "col-12" : "col-6"} `}>
              <Form.Group>
                <Form.Label>Barrio</Form.Label>
                <Form.Select isInvalid={!!errors.barrio} {...register("barrio")}>
                  <option value="">Seleccione un barrio</option>
                  {barrios?.map((barrio, index) => (
                    <option key={index} value={barrio.nombre}>
                      {barrio.nombre}
                    </option>
                  ))}
                </Form.Select>
                <Form.Control.Feedback className="mensajeError-sm mensajeError-md" type="invalid">
                  {errors.barrio?.message}
                </Form.Control.Feedback>
                {!errors.barrio?.message && <div style={{ height: "25px" }}></div>}
              </Form.Group>
              {
                sectoresState?.length > 0 ? (
                  <Form.Group>
                    <Form.Label>Sector</Form.Label>
                    <Form.Select isInvalid={!!errors.sector} {...register("sector")}>
                      <option value="">Seleccione un barrio</option>
                      {sectoresState?.map((sector) => (
                        <option key={sector.id} value={sector.nombre}>
                          {sector.nombre}
                        </option>
                      ))}
                      <option value="Otro">Otro</option>
                    </Form.Select>
                    <Form.Control.Feedback
                      className="mensajeError-sm mensajeError-md"
                      type="invalid"
                    >
                      {errors.sector?.message}
                    </Form.Control.Feedback>
                    {!errors.sector?.message && <div style={{ height: "25px" }}></div>}
                  </Form.Group>
                ) : (
                  <div style={{ height: "95px" }}></div>
                )
                // console.log(sectoresState)
              }
            </div>
            {width < 640 && (
              <>
                {watch("sector") == "Otro" && (
                  <Form.Group className={`${width >= 640 ? "col-12" : "col-12"}`}>
                    <Form.Label>Otro sector</Form.Label>
                    <Form.Control
                      placeholder="Otro sector . . ."
                      type="text"
                      {...register("otro_sector")}
                      isInvalid={!!errors.otro_sector}
                    />
                    <Form.Control.Feedback
                      className="mensajeError-sm mensajeError-md"
                      type="invalid"
                    >
                      {errors.otro_sector?.message}
                    </Form.Control.Feedback>
                    {!errors.otro_sector?.message && <div style={{ height: "25px" }}></div>}
                  </Form.Group>
                )}
              </>
            )}

            {width >= 640 && (
              <div className={` ${width <= 480 ? "col-12" : "col-6"} `}>
                <Form.Group className={`${width >= 640 ? "col-12" : "col-12"}`}>
                  <Form.Label>Domicilio</Form.Label>
                  <Form.Control
                    type="text"
                    {...register("domicilio")}
                    isInvalid={!!errors.domicilio}
                  />
                  <Form.Control.Feedback className="mensajeError-sm mensajeError-md" type="invalid">
                    {errors.domicilio?.message}
                  </Form.Control.Feedback>
                  {!errors.domicilio?.message && <div style={{ height: "25px" }}></div>}
                </Form.Group>
                {watch("sector") == "Otro" && (
                  <Form.Group className={`${width >= 640 ? "col-12" : "col-12"}`}>
                    <Form.Label>Otro sector</Form.Label>
                    <Form.Control
                      placeholder="Otro sector . . ."
                      type="text"
                      {...register("otro_sector")}
                      isInvalid={!!errors.otro_sector}
                    />
                    <Form.Control.Feedback
                      className="mensajeError-sm mensajeError-md"
                      type="invalid"
                    >
                      {errors.otro_sector?.message}
                    </Form.Control.Feedback>
                    {!errors.otro_sector?.message && <div style={{ height: "25px" }}></div>}
                  </Form.Group>
                )}
              </div>
            )}

            <div className="col-12  d-flex justify-content-center mt-2">
              <Form.Group>
                <Form.Check
                  type="checkbox"
                  id="termsConditions"
                  label="Acepto los términos y condiciones"
                  isInvalid={!!errors.acepta_condiciones}
                  {...register("acepta_condiciones")}
                />
                {errors.acepta_condiciones?.message && (
                  <span className="text-danger" style={{ fontSize: "14px" }}>
                    {errors.acepta_condiciones?.message}
                  </span>
                )}
                {!errors.acepta_condiciones?.message && <div style={{ height: "24px" }}></div>}
              </Form.Group>
            </div>
            <hr className="mt-1 mb-4" />
            <div className="d-flex justify-content-end">
              <button
                // disabled={Object.keys(errors).length !== 0}
                // className=" btn btn-success btn-sm"
                className=" btn btn-primary  btn-sm"
                style={{ width: "fit-content" }}
                type="submit"
              >
                Siguiente
                <ArrowDerechoIcon width={20} height={20} color={"#fff"} />
              </button>
            </div>
          </section>
        </Form>
      </motion.div>
    </>
  );
};
export default FormActa1;
